// extracted by mini-css-extract-plugin
export var labelWrapper = "_ey-0";